import { Radio, ThumbsDown, ThumbsUp } from '@tamagui/lucide-icons';
import { useTranslation } from 'react-i18next';
import { YStack, Text, XStack } from 'tamagui';
import { gradients } from 'tamagui-config';

import { TripleGlowBackground } from './TripleGlowBackground';

export enum WidgetCardStatuses {
  OFFLINE,
  ONLINE,
  HEALTHY,
  NOT_HEALTHY,
}

interface WidgetCardStatusProps {
  status: WidgetCardStatuses;
}

export const WidgetCardStatus: React.FC<WidgetCardStatusProps> = ({ status }) => {
  const { t } = useTranslation();

  const getStatus = () => {
    switch (status) {
      case WidgetCardStatuses.OFFLINE:
        return (
          <>
            <TripleGlowBackground gradientColors={gradients.error} />
            <XStack alignItems="center" justifyContent="center" gap="$5">
              <Radio size={64} color="$color" />
              <Text fontSize="$12" fontWeight="900">
                {t('devices.status.offline')}
              </Text>
            </XStack>
          </>
        );
      case WidgetCardStatuses.ONLINE:
        return (
          <>
            <TripleGlowBackground gradientColors={gradients.success} />
            <XStack alignItems="center" justifyContent="center" gap="$5">
              <Radio size={64} color="$color" />
              <Text fontSize="$12" fontWeight="900">
                {t('devices.status.online')}
              </Text>
            </XStack>
          </>
        );
      case WidgetCardStatuses.HEALTHY:
        return (
          <>
            <TripleGlowBackground gradientColors={gradients.success} />
            <XStack alignItems="center" justifyContent="center" gap="$5">
              <ThumbsUp size={64} color="$color" />
              <Text fontSize="$12" fontWeight="900">
                {t('devices.status.healthy')}
              </Text>
            </XStack>
          </>
        );
      case WidgetCardStatuses.NOT_HEALTHY:
        return (
          <>
            <TripleGlowBackground gradientColors={gradients.error} />
            <XStack alignItems="center" justifyContent="center" gap="$5">
              <ThumbsDown size={64} color="$color" />
              <Text fontSize="$12" fontWeight="900">
                {t('devices.status.not_healthy')}
              </Text>
            </XStack>
          </>
        );
    }
  };

  return (
    <YStack alignItems="center" justifyContent="center" flex={1}>
      {getStatus()}
    </YStack>
  );
};
